export type SupportedLanguage = 'de' | 'fr' | 'en';

export const LANGUAGE_STORAGE_KEY = 'mir-ai.language';

/** Legacy key written by `i18next-browser-languagedetector`. */
const LEGACY_I18NEXT_STORAGE_KEY = 'i18nextLng';

export const DEFAULT_LANGUAGE: SupportedLanguage = 'de';

const SUPPORTED_LANGUAGE_CODES = new Set<SupportedLanguage>(['de', 'fr', 'en']);

export function isSupportedLanguage(value: unknown): value is SupportedLanguage {
  return typeof value === 'string' && SUPPORTED_LANGUAGE_CODES.has(value as SupportedLanguage);
}

/**
 * Language persisted from the account menu. Falls back to {@link DEFAULT_LANGUAGE}.
 */
export function loadInitialLanguage(): SupportedLanguage {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (isSupportedLanguage(stored)) return stored;

    const legacy = localStorage.getItem(LEGACY_I18NEXT_STORAGE_KEY)?.split('-')[0];
    if (isSupportedLanguage(legacy)) {
      persistLanguage(legacy);
      return legacy;
    }
  } catch {
    /* private mode / blocked storage */
  }
  return DEFAULT_LANGUAGE;
}

export function persistLanguage(code: SupportedLanguage): void {
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, code);
  } catch {
    /* storage unavailable — ignore */
  }
}
